import ScrollMagic from 'scrollmagic';

const Panel = () => {
  const controller = new ScrollMagic.Controller();

  const panels = document.querySelectorAll('.mx-panel-sec--2-col');

  if (!panels.length) return;

  panels.forEach(panel => {
    new ScrollMagic.Scene({ triggerElement: panel })
      .setClassToggle(panel, "active")
      .addIndicators({ name: 'panel content' })
      .addTo(controller);
  });
};

export default Panel;